export default "__VITE_ASSET__D8Elh8UG__"